import { type Reward } from '../types/earnRewardsType';

import rewardCashPng from '/img/icons/reward/rewardCash.png';
import rewardCashWebp from '/img/icons/reward/rewardCash.webp';
import rewardGemsPng from '/img/icons/reward/rewardGems.png';
import rewardGemsWebp from '/img/icons/reward/rewardGems.webp';

type Info = {
  type: 'cash' | 'tgem';
  img: { png: string; webp: string };
  amount: number;
};

const getRewardItemInfo = (item: Reward): Info => {
  const info = {
    img: { png: '', webp: '' },
    amount: 0,
  } as Info;

  if (item.reward.cash) {
    info.img.png = rewardCashPng;
    info.img.webp = rewardCashWebp;
    info.amount = item.reward.cash;
    info.type = 'cash';
  } else {
    info.img.png = rewardGemsPng;
    info.img.webp = rewardGemsWebp;
    info.amount = item.reward.tgem;
    info.type = 'tgem';
  }

  return info;
};

export { getRewardItemInfo };
